/* eslint-disable prettier/prettier */
/* eslint-disable react/no-children-prop */
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import GhostTable from "../../../components/common/new/GhostTable/GhostTable";
import { selectUserProfile } from "../../../redux/selectors/user";
import Family from "../../../services/api/Family";
import styles from "./FamilyDetails.styles";
import Structure from "./structure/Structure";
import Button from "../../../components/common/Button/index";
import { PERMISSIONS } from "../../../contants";
import useUserConfig from "../../../hooks/useUserConfig";

export const COLS = [
  {
    displayName: "RELATION",
    key: "relation",
  },
  {
    displayName: "RELATED MEMBER",
    key: "relatedMember",
  },
  // {
  //   displayName: "MEMBER ID",
  //   key: "memberId",
  // },
  // {
  //   displayName: "MEMBER NAME",
  //   key: "memberName",
  // },
  {
    displayName: "STRUCTURE",
    key: "structure",
  },
  {
    displayName: "GOHONZON STATUS",
    key: "gohonzon",
  },
  {
    displayName: "SUBSCRIPTION",
    key: "subscription",
  },
];

const getRows = (data, userData, getStructure) =>
  data?.map((memberData) => {
    const inOrg = Number(userData.districtId) === Number(memberData.districtId);
    return (
      <TableRow style={styles.tableRow}>
        <TableCell
          style={{
            ...styles.rowStyles,
            ...styles.largeItem,
            textAlign: "left",
            ...(!inOrg ? styles.redText : {}),
          }}
        >
          {memberData?.relationType ? `${memberData?.relationType} of` : "-"}
        </TableCell>
        <TableCell
          style={{
            ...styles.rowStyles,
            ...styles.largeItem,
            ...(!inOrg ? styles.redText : {}),
          }}
        >
          {memberData.fullName} ({memberData?.memberId})
        </TableCell>
        <TableCell
          style={{ ...styles.rowStyles, ...(!inOrg ? styles.redText : {}) }}
        >
          {getStructure(memberData)}
        </TableCell>
        <TableCell
          style={{
            ...styles.rowStyles,
            ...styles.smallItem,
            ...(!inOrg ? styles.redText : {}),
            textAlign: "center",
          }}
        >
          {data.gohonzon_status || "NA"}
        </TableCell>
        <TableCell
          style={{
            ...styles.rowStyles,
            ...styles.smallItem,
            ...(!inOrg ? styles.redText : {}),
          }}
        >
          <Structure center />
        </TableCell>
      </TableRow>
    );
  });

function FamilyDetail() {
  // eslint-disable-next-line no-unused-vars
  const [familyInfo, setFamilyInfo] = useState([]);
  const [membersData, setMembersData] = useState([]);
  const userData = useSelector(selectUserProfile);
  const { id } = useParams();
  const navigate = useNavigate();
  const hasPermission = useUserConfig();

  const fetchFamilyData = async (memberId) => {
    try {
      const { data } = await Family.getFamilyDetailsByMemberId(memberId);

      setFamilyInfo(data);
      setMembersData(data.familyMembers);
    } catch (error) {
      Sentry.captureException(error);
    }
    console.log("MemberData: ", membersData);
  };

  useEffect(() => {
    if (id) {
      fetchFamilyData(id);
    }
  }, [id]);

  const { familyId, familyAddress } = familyInfo;
  // const { memberId, fullName } = membersData;

  const onEditClick = () => {
    if (familyId) {
      navigate(`/family/edit/${familyId}`);
    }
  };

  const getStructure = (data) => {
    if (!data) return "NA";
    return `${data.areaName ?? ""}/${data.clusterName ?? ""}/${
      data.zoneName ?? ""
    }/${data.regionName ?? ""}/${data.chapterName ?? ""}/${
      data.districtName ?? ""
    }/${data?.blockName ?? ""}`;
  };

  return (
    <div style={{ ...styles.container }}>
      <div>
        <Box
          sx={{
            display: "flex",
            marginTop: "4px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box style={styles.inforTitle}>Family Details</Box>
          <Box sx={{ color: "#8C8C8C" }}>
            {" "}
            Family ID:
            <Box
              component="span"
              sx={{ color: "#183053", fontWeight: "600px", marginLeft: "14px" }}
            >
              {familyId}
            </Box>
          </Box>
        </Box>
        <Box style={{ ...styles.flexContainer }} my="28px">
          <Box style={{ ...styles.keyStyle, minWidth: "200px" }}>
            Family Address
          </Box>
          <Box style={{ ...styles.valueStyle, maxWidth: "300px" }}>
            {familyAddress || "NA"}
          </Box>
        </Box>
        <Box style={styles.inforTitle}> Family Members</Box>
      </div>
      <GhostTable
        columns={COLS}
        rows={getRows(membersData, userData, getStructure)}
      />
      {hasPermission(PERMISSIONS.UPDATE_FAMILY) && (
        <Button
          variant="contained"
          style={styles.buttonStyles}
          label="EDIT DETAILS"
          onClick={onEditClick}
        />
      )}
    </div>
  );
}

export default FamilyDetail;
